import { theme } from '../theme';

export const animatedPulse = (isActive = true, color = `${theme.palette.primary.main}80`) => {
	return {
		...(!isActive
			? {}
			: {
					animation: 'pulse 1.5s infinite',
					'@keyframes pulse': {
						'0%': {
							boxShadow: `0 0 0 0 ${color}`,
						},
						'70%': {
							boxShadow: `0 0 0 10px ${color.slice(0, -2) + '00'}`, // Adjust transparency
						},
						'100%': {
							boxShadow: `0 0 0 0 ${color.slice(0, -2) + '00'}`,
						},
					},
			  }),
	};
};
